'use client';

import { FC } from 'react';

import { Checkbox } from 'src/general/components/forms/Input/atoms/OptionFieldInput';

import { FormGenericError } from '../forms/FormGenericError/FormGenericError';
import { FormWithAction } from '../forms/FormWithAction/FormWithAction';
import type { InputOption } from '../forms/Input/Input.type';
import { InputCheckboxForm } from '../forms/Input/InputCheckboxForm';
import { subscribeFormInterestAction } from './SubscribeFormInterest.action';
import { SubscribeFormSubmitButton } from './SubscribeFormSubmitButton';

type Props = {
  email: string;
  onSuccess: () => void;
};

const carTypesOptions: InputOption[] = [
  { value: 'car_types/electric_vehicles', label: 'Electric vehicles (EVs)' },
  { value: 'car_types/4x4_adventure', label: '4x4s & adventure machines' },
  { value: 'car_types/family_safe', label: 'Family-friendly & safe cars' },
  { value: 'car_types/sport_performance', label: 'Sports & performance cars' },
  { value: 'car_types/utes_work', label: 'Utes & work vehicles' },
  { value: 'car_types/hybrids_fuel_efficient', label: 'Hybrids & fuel efficient cars' },
];

const tipsIdeasOptions: InputOption[] = [
  { value: 'tips_ideas/care_maintenance', label: 'Care & maintenance tips' },
  { value: 'tips_ideas/buying_selling', label: 'Buying & selling advice' },
  { value: 'tips_ideas/lifestyle_travel', label: 'Lifestyle & travel ideas' },
  { value: 'tips_ideas/news', label: 'News & hot topics' },
];

export const SubscribeFormInterest: FC<Props> = ({ email, onSuccess }) => {
  return (
    <FormWithAction
      action={subscribeFormInterestAction}
      withRecaptcha="newsletter"
      onSuccess={onSuccess}
      renderContent={(state) => (
        <>
          <header className="mb-4">
            <h2 className="c-fs-h6 font-extrabold">
              You have subscribed! <br />
              Let us know what you’d like to hear about.
            </h2>
          </header>

          <input type="hidden" name="email" value={email} />

          <InputCheckboxForm
            label="Types of cars"
            name="interests"
            data-testid="car-types"
            inputIcon={Checkbox}
            options={carTypesOptions}
            formState={state}
            variant="group"
            hasTwoColumnsLayout="mdOnly"
          />

          <InputCheckboxForm
            label="Tips & ideas"
            name="interests"
            data-testid="tips-ideas"
            inputIcon={Checkbox}
            options={tipsIdeasOptions}
            formState={state}
            variant="group"
            hasTwoColumnsLayout="mdOnly"
          />

          <FormGenericError formState={state} />

          <SubscribeFormSubmitButton>Submit</SubscribeFormSubmitButton>
        </>
      )}
    />
  );
};
